import React from "react";
import style from "css/landing.module.css";
import ProductCardItem from "./productCardItem";
import { useMediaQuery } from "react-responsive";

/**
 * 파일명: ProductArea.js
 * 작성자: 강연승
 * 작성일자: 24.02.15
 * 설명: landing page - ProductArea
 */

function ProductArea() {
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const productList = [
    {
      KEY: "CAD",
      TITLE: "CAD/CAM",
      SUBTITLE: "All about CAD/CAM",
      SUBTITLE2: "캐드의 모든 것",
      IMG: "product_cad.png",
    },
    {
      KEY: "Microsoft",
      TITLE: "Microsoft",
      SUBTITLE: "성과 달성을 위한",
      SUBTITLE2: "소프트웨어",
      IMG: "product_ms.png",
    },
    {
      KEY: "Adobe",
      TITLE: "Adobe",
      SUBTITLE: "상상하는 무엇이든",
      SUBTITLE2: "제작할 수 있는 Adobe",
      IMG: "product_adobe.png",
    },
    {
      KEY: "Landering",
      TITLE: "랜더링",
      SUBTITLE: "3D 모델링과 디자인의 기준을",
      SUBTITLE2: "제시하는 강력한 소프트웨어",
      IMG: "product_lan.png",
    },
    {
      KEY: "Documents",
      TITLE: "문서/자산 관리",
      SUBTITLE: "효율적인 문서 관리,",
      SUBTITLE2: "체계적인 자산 관리 프로그램",
      IMG: "product_doc.png",
    },
    {
      KEY: "Security",
      TITLE: "보안 솔루션",
      SUBTITLE: "기업과 개인을 보호하는",
      SUBTITLE2: "강력한 보안 솔루션",
      IMG: "product_sec.png",
    },
  ];

  return (
    <div className={style.wrapper}>
      <div
        className={style.background}
        style={
          isMobile
            ? {
                backgroundImage:
                  "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/landing/product_bgm.png')",
              }
            : {
                backgroundImage:
                  "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/landing/product_bg.png')",
              }
        }
      />

      <div className={style.product_area}>
        <div className={style.product_title}>Product</div>
        <div className={style.product_subtitle}>
          <div className={style.product_description}>
            {isMobile || isTablet ? (
              <p>
                <font>기업의 소프트웨어를 전문</font>으로 관리하는{"\n"}{" "}
                소프트닥터입니다.
              </p>
            ) : (
              <p>
                <font>기업의 소프트웨어를 전문</font>으로 관리하는
                소프트닥터입니다.
              </p>
            )}
          </div>
          <div className={style.product_description}>
            {isMobile
              ? "soft doctor who specializes \n in managing corporate software"
              : isTablet
              ? "soft doctor who specializes \n in managing corporate software"
              : "soft doctor who specializes in managing corporate software"}
          </div>
        </div>
        <div className={style.product_card_list}>
          {isMobile || isTablet ? (
            productList.map((item, idx) => (
              <div key={idx} className={style.product_card_wrapper}>
                <ProductCardItem product={item} />
              </div>
            ))
          ) : (
            <>
              <div className={style.product_card_wrapper}>
                <ProductCardItem product={productList[0]} />
                <ProductCardItem product={productList[1]} />
                <ProductCardItem product={productList[2]} />
              </div>
              <div className={style.product_card_wrapper}>
                <ProductCardItem product={productList[3]} />
                <ProductCardItem product={productList[4]} />
                <ProductCardItem product={productList[5]} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductArea;
